import { useQuery } from 'react-query';
import { getLecture } from '../../apis/V2/lecture';

export const useLecture = (lectureId?: string) => {
	return useQuery({
		queryKey: ['getLectureId', lectureId],
		queryFn: async () => (await getLecture({ lectureId })).data?.lecture as any,
		staleTime: 60000,
		retry: false,
		refetchOnWindowFocus: false,
		enabled: !!lectureId,
	});
};
